import { render, staticRenderFns } from "./ModalProduct.vue?vue&type=template&id=56c8cdfc&"
import script from "./ModalProduct.vue?vue&type=script&lang=js&"
export * from "./ModalProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports